module.exports = __webpack_public_path__ + "static/media/michael-romrell.9e90411a.jpeg";